import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Feather = function Feather(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M5 10.6628c0-.2446 0-.3669.0276-.482a1.0002 1.0002 0 0 1 .1198-.289c.0618-.101.1483-.1874.3212-.3604L10.5 4.5001c.239-.239.3584-.3585.4642-.4546 2.2885-2.0802 5.7831-2.0802 8.0716 0 .1058.0961.2252.2156.4642.4546s.3584.3584.4546.4642c2.0802 2.2885 2.0802 5.7831 0 8.0715-.0962.1058-.2156.2253-.4546.4643l-5.0314 5.0313c-.1729.173-.2594.2595-.3603.3213a1.0007 1.0007 0 0 1-.2891.1197c-.1151.0277-.2374.0277-.4819.0277H6.6c-.56 0-.84 0-1.054-.109a1.0005 1.0005 0 0 1-.437-.437C5 18.2401 5 17.9601 5 17.4001v-6.7373Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 8 2 22.0002m16-7H9m-2.4 4h6.7373c.2445 0 .3668 0 .4819-.0277a1.0007 1.0007 0 0 0 .2891-.1197c.1009-.0618.1874-.1483.3603-.3213L19.5 13.5001c.239-.239.3584-.3585.4546-.4643 2.0802-2.2884 2.0802-5.783 0-8.0715-.0962-.1058-.2156-.2253-.4546-.4642-.239-.239-.3584-.3585-.4642-.4546-2.2885-2.0802-5.7831-2.0802-8.0716 0-.1058.0961-.2252.2156-.4642.4546L5.4686 9.5314c-.173.173-.2594.2595-.3212.3604a1.0002 1.0002 0 0 0-.1198.289C5 10.2959 5 10.4182 5 10.6628v6.7373c0 .56 0 .84.109 1.054.0959.1881.2489.3411.437.437.214.109.494.109 1.054.109Z"
    })]
  }));
};
export default Feather;